module.exports = __webpack_public_path__ + "static/media/white_grey_stripe.03b932aa.jpg";